import { Component, Inject } from './annotations';
import { ScrollService } from "./common/scroll-service";

@Component({
	selector: 'app',
	template: require('./app-component.html')
})
export class AppComponent {
	constructor(@Inject('ScrollService') private scrollService: ScrollService) {
	}

	startAProject(): void {
		this.scrollService.scrollToElement('#contact');
	}
}


/** WEBPACK FOOTER **
 ** ./app/app-component.ts
 **/